import { useState, useRef, useEffect } from "react";
import FormConfirmation from "./components/FormConfirmation";
import Primaire from "./components/primaire";
import "./formulaireAbsence.css";
import { AnimatePresence, motion } from "framer-motion";

import { Link } from "react-router-dom";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import FiveDays from "./components/fiveDays";
import NineDays from "./components/nineDays";
import MariePercent from "./components/mariePercent";
import SundayCalendarComp from "./components/SundayCalendarComp";
import schools from "./schools.json";
import Select from "react-select";
import EmailVerification from "./components/EmailVerification";
import PercentInput from "./components/PercentInput";

function FormulaireAbsence() {
  useEffect(() => {
    document.title = "SEVF | Congé sans traitement";
  }, []);

  const [submittedData, setSubmittedData] = useState(null);
  const [submitError, setSubmitError] = useState(null);

  const [formErrors, setFormErrors] = useState({});

  const [formValidated, setFormValidated] = useState(false);
  const [firstFormValidation, setFirstFormValidation] = useState(false);
  const [acknowledgeWarnings, setAcknowledgeWarnings] = useState(false);
  const [acknowledgeSignature, setAcknowledgeSignature] = useState(false);
  const [loading, setLoading] = useState(false);
  const apiUrl = process.env.REACT_APP_API_URL;

  const [form_Data, set_Form_Data] = useState({
    firstName: "",
    lastName: "",
    establishment: "",
    matricule: "",
    phoneNumber: "",
    formType: "",
    leaveRequestType: "",
    discipline: "",
    otherPercent: false,
    reason: "",
    schoolYear: "",
    humanitaireDetails: "",
    reasonChoice: "",
    justification: "",
    percent: "",
    percentChoice: "predefined", // "", "predefined" or "other"
    dateType: "",
    startDate: null,
    endDate: null,
    fullScholaryYear: false,
    file: null,
    getLetterByEmail: "true",
    leaveDetail: "",
    emailToVerify: "",
    verificationCode: "",
    emailVerified: false,
  });

  const initialFormData = {
    firstName: "",
    lastName: "",
    establishment: "",
    matricule: "",
    phoneNumber: "",
    formType: "",
    leaveRequestType: "",
    discipline: "",
    reason: "",
    schoolYear: "",
    humanitaireDetails: "",
    reasonChoice: "",
    justification: "",
    percent: "",
    percentChoice: "predefined", // "", "predefined" or "other"
    dateType: "",
    startDate: null,
    endDate: null,
    fullScholaryYear: false,
    file: null,
    getLetterByEmail: "true",
    leaveDetail: "",
    emailToVerify: "",
    verificationCode: "",
    emailVerified: false,
  };

  const firstNameRef = useRef(null);
  const lastNameRef = useRef(null);
  const establishmentRef = useRef(null);
  const matriculeRef = useRef(null);
  const fileInputRef = useRef(null);
  const phoneRef = useRef(null);
  const leaveRequestTypeRef = useRef(null);
  const dateTypeRef = useRef(null);
  const disciplineTaskReductionRef = useRef(null);
  const disciplineNoTreatmentRef = useRef(null);
  const preschoaireRef = useRef(null);
  const acknowledgeWarningsRef = useRef(null);
  const acknowledgeSignatureRef = useRef(null);
  const formTypeRef = useRef(null);

  // Handle date type change
  const handleDateTypeChange = (e) => {
    const { value } = e.target;
    if (value === "anneeScolaire") {
      const date = new Date();
      const schoolYear =
        date.getMonth() < 7 || (date.getMonth() === 7 && date.getDate() < 15)
          ? `${date.getFullYear()}-${date.getFullYear() + 1}`
          : `${date.getFullYear() + 1}-${date.getFullYear() + 2}`;

      set_Form_Data((prevData) => {
        const updatedData = {
          ...prevData,
          dateType: value,
          startDate: "fullScholaryYear",
          endDate: "fullScholaryYear",
          fullScholaryYear: true,
          schoolYear: schoolYear,
        };
        if (firstFormValidation) {
          setFormErrors(
            validateFormData(
              updatedData,
              acknowledgeWarnings,
              acknowledgeSignature,
            ),
          );
        }
        return updatedData;
      });
    } else {
      set_Form_Data((prevData) => {
        const updatedData = {
          ...prevData,
          dateType: value,
          startDate: null,
          endDate: null,
          fullScholaryYear: false,
        };
        if (firstFormValidation) {
          setFormErrors(
            validateFormData(
              updatedData,
              acknowledgeWarnings,
              acknowledgeSignature,
            ),
          );
        }
        return updatedData;
      });
    }
  };

  const handleFileInputChange = (e) => {
    const file = e.target.files[0];
    if (file.size > 20 * 1024 * 1024) {
      // File too large: update file to null and set file error.
      set_Form_Data((prevData) => {
        const updatedData = { ...prevData, file: null };
        if (firstFormValidation) {
          const updatedErrors = validateFormData(
            updatedData,
            acknowledgeWarnings,
            acknowledgeSignature,
          );
          updatedErrors.file = "Le fichier ne doit pas dépasser 20 MB.";
          setFormErrors(updatedErrors);
        }
        return updatedData;
      });
    } else {
      set_Form_Data((prevData) => {
        const updatedData = { ...prevData, file: file };
        if (firstFormValidation) {
          const updatedErrors = validateFormData(
            updatedData,
            acknowledgeWarnings,
            acknowledgeSignature,
          );
          updatedErrors.file = null; // clear file error if any
          setFormErrors(updatedErrors);
        }
        return updatedData;
      });
    }
  };

  const handleMarieChange = (e) => {
    const { value } = e.target;
    // Set RadioButton Label to be the leave Detail
    const selectedOption = e.target.nextSibling.textContent;

    set_Form_Data((prevData) => {
      const updatedData = {
        ...prevData,
        percentChoice: "predefined",
        otherPercent: false,
        percent: value,
        leaveDetail: `${selectedOption}`,
      };
      if (firstFormValidation) {
        setFormErrors(
          validateFormData(
            updatedData,
            acknowledgeWarnings,
            acknowledgeSignature,
          ),
        );
      }
      return updatedData;
    });
  };

  const handlePrimaireChange = () => {
    set_Form_Data((prevData) => {
      const updatedData = {
        ...prevData,
        otherPercent: false,
        percent: "19.51",
        leaveDetail:
          "Primaire, par 10 jours (Congé de 19,51%): 2 journées de congé de 4 périodes",
      };
      if (firstFormValidation) {
        setFormErrors(
          validateFormData(
            updatedData,
            acknowledgeWarnings,
            acknowledgeSignature,
          ),
        );
      }
      return updatedData;
    });
  };

  const handleDisciplineChange = (e) => {
    const { value } = e.target;
    set_Form_Data((prevData) => {
      const primaireOptions = [
        "TitulairePrimaire",
        "AdaptionScholaire",
        "AnglaisPrimaire",
        "MusiquePrimaire",
        "ArtsPrimaire",
        "EducationPhysiquePrimaire",
      ];
      const isPrimaireToPrimaire =
        primaireOptions.includes(prevData.discipline) &&
        primaireOptions.includes(value);
      const isNewPrimaire =
        !primaireOptions.includes(prevData.discipline) &&
        primaireOptions.includes(value);

      let newPercent = "";
      let newLeaveDetail = "";

      if (isPrimaireToPrimaire) {
        // Keep existing percent when switching between primaire options
        newPercent = prevData.percent;
        newLeaveDetail = prevData.leaveDetail;
      } else if (isNewPrimaire && prevData.percentChoice === "predefined") {
        // Set default percent when entering primaire with predefined choice
        newPercent = "19.51";
        newLeaveDetail =
          "Primaire, par 10 jours (Congé de 19,51%): 2 journées de congé de 4 périodes";
      }

      const updatedData = {
        ...prevData,
        discipline: value,
        percent: newPercent,
        leaveDetail: newLeaveDetail,
      };
      if (firstFormValidation) {
        setFormErrors(
          validateFormData(
            updatedData,
            acknowledgeWarnings,
            acknowledgeSignature,
          ),
        );
      }
      return updatedData;
    });
  };

  const handleHumanitaireDetailsChange = (e) => {
    const { value } = e.target;
    set_Form_Data((prevData) => {
      const updatedData = { ...prevData, humanitaireDetails: value };
      if (firstFormValidation) {
        setFormErrors(
          validateFormData(
            updatedData,
            acknowledgeWarnings,
            acknowledgeSignature,
          ),
        );
      }
      return updatedData;
    });
  };

  const handleFormTypeChange = (e) => {
    const { value } = e.target;
    set_Form_Data((prevData) => {
      // reset other fields when form type changes
      const updatedData = {
        ...prevData,
        formType: value,
        leaveRequestType: "",
        discipline: "",
        percent: value === "noTreatment" ? 100 : null,
        justification: "",
        reason: "",
        reasonChoice: "",
        humanitaireDetails: "",
        dateType: "",
        startDate: null,
        endDate: null,
        fullScholaryYear: false,
        schoolYear: "",
        leaveDetail: "",
        file: null,
        getLetterByEmail: "true",
      };
      if (firstFormValidation) {
        setFormErrors(
          validateFormData(
            updatedData,
            acknowledgeWarnings,
            acknowledgeSignature,
          ),
        );
      }
      return updatedData;
    });
  };

  const handleOtherPercentChange = (e) => {
    const isChecked = e.target.checked;

    set_Form_Data((prevData) => {
      const updatedData = {
        ...prevData,
        percentChoice: isChecked ? "other" : "",
        otherPercent: isChecked,
        percent: "",
        leaveDetail: "",
      };
      if (firstFormValidation) {
        setFormErrors(
          validateFormData(
            updatedData,
            acknowledgeWarnings,
            acknowledgeSignature,
          ),
        );
      }
      return updatedData;
    });
  };

  const handleLeaveRequestTypeChange = (e) => {
    const { value } = e.target;
    set_Form_Data((prevData) => {
      const updatedData = {
        ...prevData,
        leaveRequestType: value,
        discipline: "",
        percent: value === "noTreatment" ? 100 : null,
        justification: "",
        reason: "",
      };
      if (firstFormValidation) {
        setFormErrors(
          validateFormData(
            updatedData,
            acknowledgeWarnings,
            acknowledgeSignature,
          ),
        );
      }
      return updatedData;
    });
  };

  const handlePhoneChange = (value) => {
    set_Form_Data((prevData) => {
      const updatedData = { ...prevData, phoneNumber: value };
      if (firstFormValidation) {
        setFormErrors(
          validateFormData(
            updatedData,
            acknowledgeWarnings,
            acknowledgeSignature,
          ),
        );
      }
      return updatedData;
    });
  };

  // A custom handler for the 5 and 9 days percentage change that will also provide the number of 60 and
  //  minutes periods
  const handlePercentChangeFor5And9Days = (total, index60, index75) => {
    set_Form_Data((prevData) => {
      const updatedData = {
        ...prevData,
        percent: total,
        leaveDetail:
          prevData.discipline === "EnseignantSecondaire5Jours"
            ? `Enseignant(e) au secondaire avec un horaire sur 5 jours: Congé de ${total}% pour ${index60} période${
                index60 === 1 ? "" : "s"
              } de 60 minutes et ${index75} période${
                index75 === 1 ? "" : "s"
              } de 75 minutes.`
            : prevData.discipline === "EnseignantSecondaire9Jours"
              ? `Enseignant(e) au secondaire avec un horaire sur 9 jours: Congé de ${total}% pour ${index60} période${
                  index60 === 1 ? "" : "s"
                } de 60 minutes et ${index75} période${
                  index75 === 1 ? "" : "s"
                } de 75 minutes.`
              : "",
      };
      if (firstFormValidation) {
        setFormErrors(
          validateFormData(
            updatedData,
            acknowledgeWarnings,
            acknowledgeSignature,
          ),
        );
      }
      return updatedData;
    });
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    set_Form_Data((prevData) => {
      const updatedData = { ...prevData, [name]: value };
      if (firstFormValidation) {
        setFormErrors(
          validateFormData(
            updatedData,
            acknowledgeWarnings,
            acknowledgeSignature,
          ),
        );
      }
      return updatedData;
    });
  };

  const handleReasonChange = (e) => {
    const { value } = e.target;
    set_Form_Data((prevData) => {
      const updatedData = { ...prevData, reason: value };
      if (firstFormValidation) {
        setFormErrors(
          validateFormData(
            updatedData,
            acknowledgeWarnings,
            acknowledgeSignature,
          ),
        );
      }
      return updatedData;
    });
  };

  const handleReasonChoice = (e) => {
    const { value } = e.target;

    set_Form_Data((prevData) => {
      const updatedData = {
        ...prevData,
        reasonChoice: value,
      };

      if (firstFormValidation) {
        const updatedErrors = validateFormData(
          updatedData,
          acknowledgeWarnings,
          acknowledgeSignature,
        );
        setFormErrors(updatedErrors);
      }

      return updatedData;
    });
  };

  const handleAcknowledgeChange = (e) => {
    const newVal = e.target.checked;
    setAcknowledgeWarnings(newVal);
    if (firstFormValidation) {
      const updatedErrors = validateFormData(
        form_Data,
        newVal,
        acknowledgeSignature,
      );
      setFormErrors(updatedErrors);
    }
  };

  const handleAcknowledgeSignatureChange = (e) => {
    const newVal = e.target.checked;
    setAcknowledgeSignature(newVal);
    if (firstFormValidation) {
      const updatedErrors = validateFormData(
        form_Data,
        acknowledgeWarnings,
        newVal,
      );
      setFormErrors(updatedErrors);
    }
  };

  const validateFormData = (
    form_Data,
    acknowledgeWarnings,
    acknowledgeSignature,
  ) => {
    const errors = {};

    // Validate firstName
    if (!form_Data.firstName) {
      errors.firstName = "Le prénom est requis.";
    } else if (/\d/.test(form_Data.firstName)) {
      errors.firstName = "Le prénom ne doit pas contenir de chiffres.";
    }

    // Validate lastName
    if (!form_Data.lastName) {
      errors.lastName = "Le nom est requis.";
    } else if (/\d/.test(form_Data.lastName)) {
      errors.lastName = "Le nom ne doit pas contenir de chiffres.";
    }

    // Validate establishment
    if (!form_Data.establishment) {
      errors.establishment = "Le nom de l'école est requis.";
    }

    // Validate matricule
    if (!form_Data.matricule) {
      errors.matricule = "Le numéro de matricule est requis.";
    } else if (form_Data.matricule.length > 7) {
      errors.matricule =
        "Le numéro de matricule ne doit pas dépasser 7 chiffres.";
    }

    // Validate phoneNumber
    if (!form_Data.phoneNumber) {
      errors.phoneNumber = "Le numéro de téléphone est requis.";
    } else if (form_Data.phoneNumber.length !== 12) {
      errors.phoneNumber = "Le numéro de téléphone doit contenir 10 chiffres.";
    }

    // Validate formType
    if (!form_Data.formType) {
      errors.formType = "Veuillez sélectionner un type de demande.";
    }

    // Only validate signature and email for cancelLeaveRequest
    if (form_Data.formType === "cancelLeaveRequest") {
      if (!acknowledgeSignature) {
        errors.acknowledgeSignature =
          "Veuillez confirmer que vous avez lu et compris les informations fournies.";
      }
      if (!form_Data.emailVerified) {
        errors.emailVerification = "Veuillez vérifier votre adresse e-mail.";
      }
      return errors;
    }

    // Validate dateType
    if (!form_Data.dateType) {
      errors.dateType = "Veuillez sélectionner une option.";
    }

    // Validate leaveRequestType
    if (!form_Data.leaveRequestType) {
      errors.leaveRequestType = "Veuillez sélectionner une option.";
    }

    // Validate discipline for taskReduction
    if (
      form_Data.leaveRequestType === "taskReduction" &&
      (!form_Data.discipline || form_Data.discipline === "")
    ) {
      errors.discipline = "Veuillez sélectionner une option.";
    }

    // Validate reason and related fields
    if (form_Data.reason === "causeHumanitaire") {
      if (!form_Data.humanitaireDetails) {
        errors.humanitaireDetails = "Veuillez décrire la cause humanitaire.";
      }
    } else if (!form_Data.reason) {
      errors.reason = "Veuillez sélectionner une option.";
    } else if (
      (form_Data.reason === "causeMort" ||
        form_Data.reason === "causeMaladie") &&
      !form_Data.reasonChoice
    ) {
      errors.reasonChoice = "Veuillez sélectionner une option.";
    }

    // Validate percent and acknowledgment
    if (form_Data.percent < 0) {
      errors.percent = "Le pourcentage ne peut pas être négatif.";
    } else if (form_Data.percent > 100) {
      errors.percent = "Le pourcentage ne peut pas être supérieur à 100.";
    } else if (
      !form_Data.percent &&
      form_Data.leaveRequestType === "taskReduction"
    ) {
      errors.percent = "Veuillez entrer un pourcentage.";
    } else if (Number(form_Data.percent) === 0) {
      errors.percent = "Le pourcentage ne peut pas être 0.";
    } else if (form_Data.percent > 20 && !acknowledgeWarnings) {
      errors.acknowledgeWarnings =
        "Vous devez confirmer que vous comprenez les avertissements.";
    }

    // Validate schoolYear for fullScholaryYear
    if (form_Data.startDate === "fullScholaryYear" && !form_Data.schoolYear) {
      errors.schoolYear = "Veuillez sélectionner une option.";
    }

    // Validate date range if "choixDeDate" is selected
    if (form_Data.dateType === "choixDeDate") {
      if (!form_Data.startDate || !form_Data.endDate) {
        errors.dateRange =
          "Veuillez sélectionner les dates de début et de fin.";
      } else if (form_Data.startDate >= form_Data.endDate) {
        errors.dateRange =
          "La date de début doit être antérieure à la date de fin.";
      }
    }

    if (!acknowledgeSignature) {
      errors.acknowledgeSignature =
        "Veuillez confirmer que vous avez lu et compris les informations fournies.";
    }

    if (!form_Data.emailVerified) {
      errors.emailVerification = "Veuillez vérifier votre adresse e-mail.";
    }

    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = validateFormData(
      form_Data,
      acknowledgeWarnings,
      acknowledgeSignature,
    );

    if (!firstFormValidation) {
      setFirstFormValidation(true);
    }

    if (Object.keys(errors).length === 0) {
      setFormValidated(true);
      setFormErrors({});

      try {
        setSubmitError(null);
        setLoading(true);
        // Create a FormData instance and append all fields
        const formDataToSend = new FormData();
        for (const key in form_Data) {
          if (key === "file" && form_Data.file) {
            formDataToSend.append("file", form_Data.file);
          } else {
            formDataToSend.append(key, form_Data[key]);
          }
        }

        // Also append acknowledgeWarnings if needed
        formDataToSend.append("acknowledgeWarnings", acknowledgeWarnings);
        // Append acknowledgeSignature if needed
        formDataToSend.append("acknowledgeSignature", acknowledgeSignature);

        // Submit the form data as multipart/form-data
        const response = await fetch(`${apiUrl}/document`, {
          method: "POST",
          // Do NOT set the Content-Type header manually.
          body: formDataToSend,
        });
        if (!response.ok) {
          const contentType = response.headers.get("content-type");
          if (contentType && contentType.includes("application/json")) {
            const errorData = await response.json();
            const messages = errorData.errors?.join(" ") || "Une erreur s'est produite.";
            throw new Error(messages);
          }
          throw new Error("Une erreur s'est produite.");
        }
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.includes("application/json")) {
          await response.json();
        } else {
          await response.text();
        }

        // Capture data for confirmation screen before resetting
        const formTypeLabels = {
          newLeaveRequest: "Nouvelle demande",
          modifyLeaveRequest: "Modification d'une demande",
          cancelLeaveRequest: "Annulation d'une demande",
        };
        const leaveTypeLabels = {
          noTreatment: "Congé sans traitement",
          taskReduction: "Réduction de tâche",
        };
        const captured = {
          name: `${form_Data.firstName} ${form_Data.lastName}`,
          matricule: form_Data.matricule,
          establishment: form_Data.establishment,
          formType: formTypeLabels[form_Data.formType] || form_Data.formType,
          leaveType:
            leaveTypeLabels[form_Data.leaveRequestType] ||
            form_Data.leaveRequestType,
          dateType:
            form_Data.dateType === "anneeScolaire"
              ? "Année scolaire complète"
              : form_Data.startDate && form_Data.endDate
                ? `${new Date(form_Data.startDate).toLocaleDateString("fr-CA")} — ${new Date(form_Data.endDate).toLocaleDateString("fr-CA")}`
                : "—",
          dateSent: new Date().toLocaleString("fr-CA", {
            dateStyle: "long",
            timeStyle: "short",
          }),
        };

        // Reset the form state
        set_Form_Data(initialFormData);
        setAcknowledgeWarnings(false);
        setFirstFormValidation(false);

        setFormValidated(false);
        setFormErrors({});

        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
        setSubmittedData(captured);
      } catch (error) {
        console.error("Error:", error);
        setSubmitError(
          error.message && error.message !== "Failed to fetch"
            ? error.message
            : "Une erreur s'est produite. Veuillez réessayer. Si le problème persiste, veuillez contacter valeriec@sevf.ca.",
        );
      } finally {
        setLoading(false);
      }
    } else {
      setFormErrors(errors);

      setFormValidated(true);

      if (errors.firstName && firstNameRef.current) {
        firstNameRef.current.scrollIntoView({ behavior: "smooth" });
      } else if (errors.lastName && lastNameRef.current) {
        lastNameRef.current.scrollIntoView({ behavior: "smooth" });
      } else if (errors.establishment && establishmentRef.current) {
        establishmentRef.current.scrollIntoView({ behavior: "smooth" });
      } else if (errors.matricule && matriculeRef.current) {
        matriculeRef.current.scrollIntoView({ behavior: "smooth" });
      } else if (errors.file && fileInputRef.current) {
        fileInputRef.current.scrollIntoView({ behavior: "smooth" });
      } else if (errors.phoneNumber && phoneRef.current) {
        phoneRef.current.scrollIntoView({ behavior: "smooth" });
      } else if (errors.leaveRequestType && leaveRequestTypeRef.current) {
        leaveRequestTypeRef.current.scrollIntoView({ behavior: "smooth" });
      } else if (
        errors.discipline &&
        form_Data.leaveRequestType === "taskReduction" &&
        disciplineTaskReductionRef.current
      ) {
        disciplineTaskReductionRef.current.scrollIntoView({
          behavior: "smooth",
        });
      } else if (
        errors.discipline &&
        form_Data.leaveRequestType === "noTreatment" &&
        disciplineNoTreatmentRef.current
      ) {
        disciplineNoTreatmentRef.current.scrollIntoView({
          behavior: "smooth",
        });
      } else if ((errors.dateRange || errors.dateType) && dateTypeRef.current) {
        dateTypeRef.current.scrollIntoView({ behavior: "smooth" });
      } else if (
        errors.percent &&
        form_Data.leaveRequestType === "noTreatment" &&
        form_Data.discipline === "Prescolaire" &&
        preschoaireRef.current
      ) {
        preschoaireRef.current.scrollIntoView({
          behavior: "smooth",
        });
      }
    }
  };

  const FileInput = () => {
    return (
      <div ref={fileInputRef}>
        <p
          style={{
            fontSize: "0.875rem",
            fontWeight: 600,
            color: "#414751",
            marginBottom: "0.5rem",
          }}
        >
          Veuillez téléverser le document : (DOCX, PDF, DOC, JPG, PNG, JPEG)
        </p>
        <p
          style={{
            fontSize: "0.8rem",
            color: "#005ca8",
            marginBottom: "0.5rem",
          }}
        >
          Maximum 20 MB
        </p>
        <div className="custom-file-input">
          <input
            type="file"
            id="fileInput"
            style={{ display: "none" }}
            accept=".docx,.pdf,.doc,.jpg,.png,.jpeg"
            onChange={handleFileInputChange}
          />
          <label
            htmlFor="fileInput"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "0.5rem",
              backgroundColor: "#ffffff",
              border: "1.5px solid #00447f",
              borderRadius: "0.5rem",
              padding: "0.6rem 1.25rem",
              fontSize: "0.875rem",
              fontWeight: 600,
              color: "#00447f",
              cursor: "pointer",
            }}
          >
            {form_Data.file ? form_Data.file.name : "Choisir un fichier"}
          </label>
        </div>
        {formErrors.file && (
          <p
            style={{
              color: "#ba1a1a",
              fontSize: "0.8rem",
              marginTop: "0.25rem",
            }}
          >
            {formErrors.file}
          </p>
        )}
      </div>
    );
  };

  const ChoixCauseMort = () => {
    const choixOptions = [
      { id: "choixConjoint", value: "conjoint", label: "Conjoint(e)" },
      { id: "choixEnfant", value: "enfant", label: "Enfant" },
      { id: "choixPere", value: "pere", label: "Père" },
      { id: "choixMere", value: "mere", label: "Mère" },
      {
        id: "choixEnfantConjoint",
        value: "enfantConjoint",
        label: "Enfant de conjoint(e)",
      },
    ];
    return (
      <div
        style={{
          marginTop: "0.75rem",
          padding: "1rem",
          backgroundColor: "#f2f3fe",
          borderRadius: "0.5rem",
        }}
      >
        <p
          style={{
            fontSize: "0.875rem",
            fontWeight: 600,
            color: "#414751",
            marginBottom: "0.5rem",
          }}
        >
          Sélectionner l'une des options ci-dessous :
        </p>
        <div
          style={{ display: "flex", flexDirection: "column", gap: "0.4rem" }}
        >
          {choixOptions.map((opt) => (
            <label
              key={opt.id}
              htmlFor={opt.id}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "0.6rem",
                backgroundColor:
                  form_Data.reasonChoice === opt.value
                    ? "rgba(0,68,127,0.08)"
                    : "#ffffff",
                border:
                  form_Data.reasonChoice === opt.value
                    ? "1.5px solid #00447f"
                    : "1.5px solid #e2e4ea",
                borderRadius: "0.4rem",
                padding: "0.6rem 1rem",
                cursor: "pointer",
                fontSize: "0.875rem",
                color: "#181c23",
              }}
            >
              <input
                type="radio"
                id={opt.id}
                name="choixCause"
                value={opt.value}
                checked={form_Data.reasonChoice === opt.value}
                onChange={handleReasonChoice}
                style={{
                  accentColor: "#00447f",
                  width: 16,
                  height: 16,
                  flexShrink: 0,
                  cursor: "pointer",
                }}
              />
              {opt.label}
            </label>
          ))}
        </div>
        {formErrors.reasonChoice && (
          <p
            style={{
              color: "#ba1a1a",
              fontSize: "0.8rem",
              marginTop: "0.4rem",
            }}
          >
            {formErrors.reasonChoice}
          </p>
        )}
      </div>
    );
  };

  const NatureCongeSansTraitement = () => {
    const optionStyle = (value) => ({
      display: "flex",
      alignItems: "flex-start",
      gap: "0.75rem",
      backgroundColor:
        form_Data.reason === value ? "rgba(0,68,127,0.08)" : "#ffffff",
      border:
        form_Data.reason === value
          ? "1.5px solid #00447f"
          : "1.5px solid #e2e4ea",
      borderRadius: "0.5rem",
      padding: "0.875rem 1.25rem",
      cursor: "pointer",
      marginBottom: "0.5rem",
    });
    return (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3 }}
        ref={disciplineNoTreatmentRef}
      >
        <section
          style={{
            backgroundColor: "#f2f3fe",
            borderRadius: "0.75rem",
            padding: "2rem",
            border: formErrors.reason ? "1.5px solid #ba1a1a" : "none",
          }}
        >
          <div style={sectionHeaderStyle}>
            <span style={sectionBadgeStyle}>6</span>
            <h2 style={sectionTitleStyle}>Nature du congé</h2>
          </div>
          {/* Todo : Add a new radio button option for this choice to specify which
        member passed away (father, mother, child, spouse) */}
          <div
            style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}
          >
            {[
              {
                id: "causeMort",
                name: "nature_conge",
                value: "decesPleinConge",
                label:
                  "À la suite du décès de sa conjointe ou son conjoint, de son enfant, de son père ou de sa mère à l'égard de toute période comprise entre la date de ce décès et la fin de l'année de travail suivant celle de ce décès. (clause 5-15.09 a))",
              },
              {
                id: "pourEtudes",
                name: "nature_conge",
                value: "etudesPleinConge",
                label:
                  "Pour commencer, poursuivre ou compléter des études de perfectionnement ou de recyclage. L'enseignante ou l'enseignant doit suivre un minimum de 12 crédits ou l'équivalent par année de travail entière en plein congé sans traitement ou un minimum de 6 crédits ou l'équivalent par année de travail entière en demi-congé sans traitement, sauf si elle ou il complète des études. Entre le début de ce congé et la fin de son dernier renouvellement, il ne peut s'écouler plus de trois ans. (clause 5-15.09 b))",
              },
              {
                id: "echangeEnseignants",
                name: "nature_conge",
                value: "echangesEnseignantsPleinConge",
                label:
                  "Pour participer à des échanges d'enseignantes ou d'enseignants approuvés par le ministère de l'Éducation. Entre le début de ce congé et la fin de son renouvellement, il ne peut s'écouler plus de deux ans. (clause 5-15.09 c))",
              },
              {
                id: "enfantMoinsCinq",
                name: "nature_conge",
                value: "enfantPleinConge",
                label:
                  "Pour prendre soin de son enfant, ou celui de sa conjointe ou son conjoint, qui a moins de 5 ans d'âge. (clause 5-15.09 d))",
              },
              {
                id: "causeMaladie",
                name: "nature_conge",
                value: "maladieGravePleinConge",
                label:
                  "Maladie grave de sa conjointe ou son conjoint, son enfant ou celui de sa conjointe ou son conjoint, son père ou sa mère. Entre le début de ce congé et la fin de son dernier renouvellement, il ne peut s'écouler plus de cinq ans. (clause 5-15.09 e))",
              },
              {
                id: "priseRetraite",
                name: "nature_conge",
                value: "retraitePleinConge",
                label:
                  "Durant les cinq années précédant la prise effective de la retraite. (clause 5-15.09 f))",
              },
              {
                id: "invalidite",
                name: "invalidite",
                value: "invalidite",
                label: "Invalidité longue durée. (clause 5-15.09 i))",
              },
              {
                id: "raisonPersonelle",
                name: "nature_conge",
                value: "persoPleinConge",
                label:
                  "Pour raison personnelle, la durée de ce congé ne peut être inférieur à 2 mois consécutifs (clause 5-15.10)",
              },
            ].map((opt) => (
              <div key={opt.id}>
                <label htmlFor={opt.id} style={optionStyle(opt.value)}>
                  <input
                    type="radio"
                    id={opt.id}
                    name={opt.name}
                    value={opt.value}
                    checked={form_Data.reason === opt.value}
                    onChange={handleReasonChange}
                    style={{
                      accentColor: "#00447f",
                      width: 18,
                      height: 18,
                      flexShrink: 0,
                      marginTop: 2,
                      cursor: "pointer",
                    }}
                  />
                  <span
                    style={{
                      fontSize: "0.875rem",
                      color: "#181c23",
                      lineHeight: 1.5,
                    }}
                  >
                    {opt.label}
                  </span>
                </label>
                {opt.value === "decesPleinConge" &&
                  form_Data.reason === "decesPleinConge" && <ChoixCauseMort />}
                {opt.value === "enfantPleinConge" &&
                  form_Data.reason === "enfantPleinConge" && <ChoixCauseMort />}
                {opt.value === "maladieGravePleinConge" &&
                  form_Data.reason === "maladieGravePleinConge" && (
                    <ChoixCauseMort />
                  )}
                {opt.value === "etudesPleinConge" &&
                  form_Data.reason === "etudesPleinConge" && (
                    <div style={{ marginTop: "0.75rem" }}>
                      <FileInput />
                    </div>
                  )}
              </div>
            ))}
          </div>

          {formErrors.reason && (
            <p
              style={{
                color: "#ba1a1a",
                fontSize: "0.8rem",
                marginTop: "0.75rem",
              }}
            >
              {formErrors.reason}
            </p>
          )}

          {form_Data.reason === "santePleinConge" && (
            <div style={{ marginTop: "0.75rem" }}>
              <FileInput />
            </div>
          )}
        </section>
      </motion.div>
    );
  };

  const primaireOptions = [
    {
      id: "TitulairePrimaire",
      label: "Titulaire primaire",
    },
    { id: "AdaptionScholaire", label: "Adaptation scolaire (primaire)" },
    { id: "AnglaisPrimaire", label: "Anglais - spécialiste primaire" },
    { id: "MusiquePrimaire", label: "Musique - spécialiste primaire" },
    { id: "ArtsPrimaire", label: "Arts - spécialiste primaire" },
    {
      id: "EducationPhysiquePrimaire",
      label: "Éducation physique - spécialiste primaire",
    },
  ];

  const inputStyle = (hasError, isValid) => ({
    width: "100%",
    backgroundColor: "#ffffff",
    border: hasError
      ? "1.5px solid #ba1a1a"
      : isValid
        ? "1.5px solid #198754"
        : "none",
    borderRadius: "0.5rem",
    padding: "0.75rem",
    boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
    outline: "none",
    fontSize: "0.95rem",
    boxSizing: "border-box",
    fontFamily: "Inter, sans-serif",
  });

  const labelStyle = {
    fontSize: "0.875rem",
    fontWeight: 600,
    color: "#414751",
    display: "block",
    marginBottom: "0.5rem",
  };

  const errorStyle = {
    color: "#ba1a1a",
    fontSize: "0.8rem",
    marginTop: "0.25rem",
  };

  const sectionHeaderStyle = {
    display: "flex",
    alignItems: "center",
    gap: "0.75rem",
    marginBottom: "2rem",
  };

  const sectionBadgeStyle = {
    backgroundColor: "#00447f",
    color: "#ffffff",
    width: 32,
    height: 32,
    borderRadius: "9999px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 700,
    flexShrink: 0,
    fontSize: "0.95rem",
  };

  const sectionTitleStyle = {
    fontSize: "1.25rem",
    fontWeight: 700,
    color: "#00447f",
    margin: 0,
    fontFamily: "Public Sans, sans-serif",
  };

  if (submittedData) {
    return (
      <FormConfirmation
        headerTitle="Formulaire de demande d'absence"
        headerSub="Demande de congé sans traitement à temps complet ou réduction de tâche."
        dateSent={submittedData.dateSent}
        details={[
          { label: "Employé(e)", value: submittedData.name },
          { label: "Matricule", value: submittedData.matricule },
          { label: "Établissement", value: submittedData.establishment },
          { label: "Type de demande", value: submittedData.formType },
          { label: "Type de congé", value: submittedData.leaveType },
          {
            label: "Période visée",
            value: submittedData.dateType,
            icon: "calendar_today",
          },
        ]}
      />
    );
  }

  return (
    <div style={{ backgroundColor: "#f9f9ff", minHeight: "100vh" }}>
      {/* Header */}
      <div
        style={{
          background: "linear-gradient(135deg, #00447f 0%, #0066cc 100%)",
          padding: "1.25rem 1.5rem",
          display: "flex",
          alignItems: "center",
          gap: "1rem",
          flexWrap: "wrap",
          boxShadow: "0 2px 12px rgba(0,68,127,0.18)",
        }}
      >
        <Link to="/">
          <img
            src="logo.jpg"
            alt="logo"
            style={{
              maxHeight: "56px",
              width: "auto",
              borderRadius: "0.5rem",
              backgroundColor: "rgba(255,255,255,0.95)",
              padding: "0.25rem",
              flexShrink: 0,
            }}
          />
        </Link>
        <div style={{ minWidth: 0 }}>
          <h1
            style={{
              color: "#ffffff",
              fontSize: "1.2rem",
              fontWeight: 700,
              margin: 0,
              lineHeight: 1.2,
            }}
          >
            Formulaire de demande d’absence sans traitement
          </h1>
          <p
            style={{
              color: "rgba(255,255,255,0.8)",
              fontSize: "0.85rem",
              margin: "0.25rem 0 0 0",
            }}
          >
            Demande de congé sans traitement à temps complet ou réduction de
            tâche.
          </p>
        </div>
      </div>

      {/* Page content */}
      <div
        style={{
          maxWidth: "64rem",
          margin: "0 auto",
          padding: "2rem 1.5rem 8rem",
        }}
      >
        {/* Notes banner */}
        <div
          style={{
            backgroundColor: "rgba(212, 227, 255, 0.35)",
            borderRadius: "0.75rem",
            padding: "1.5rem",
            marginBottom: "3rem",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "0.75rem",
              marginBottom: "0.75rem",
            }}
          >
            <span
              className="material-symbols-outlined"
              style={{
                color: "#005ca8",
                display: "inline-block",
                lineHeight: 1,
                flexShrink: 0,
              }}
            >
              info
            </span>
            <h4
              style={{
                fontWeight: 700,
                color: "#00447f",
                margin: 0,
                fontFamily: "Public Sans, sans-serif",
              }}
            >
              Remarques
            </h4>
          </div>
          <ul
            style={{
              paddingLeft: "1.75rem",
              margin: 0,
              display: "flex",
              flexDirection: "column",
              gap: "0.4rem",
            }}
          >
            <li style={{ color: "#414751", fontSize: "0.9rem" }}>
              Veuillez respecter la date limite du 8 mai 2026 à 16h00 pour
              transmettre votre demande de réduction de tâche.
            </li>
            <li style={{ color: "#414751", fontSize: "0.9rem" }}>
              Assurez-vous de respecter les{" "}
              <a
                href="/R%C3%A9duction%20de%20t%C3%A2che%20-%20Balises%20CSS-%202026-2027.pdf"
                target="_blank"
                rel="noreferrer"
                style={{
                  color: "#00447f",
                  fontWeight: "bold",
                  fontSize: "1rem",
                }}
              >
                balises du centre de services
              </a>
              ;
            </li>
            <li style={{ color: "#414751", fontSize: "0.9rem" }}>
              Si vous avez des questions, n’hésitez pas à communiquer avec
              Valérie Caissie :{" "}
              <a href="mailto:valeriec@sevf.ca" style={{ color: "#00447f" }}>
                valeriec@sevf.ca
              </a>
            </li>
            <li style={{ color: "#414751", fontSize: "0.9rem" }}>
              Suite à la transmission de votre demande, le Centre de service en
              fera l’analyse et vous rendra une décision.
            </li>
          </ul>
        </div>

        <form
          noValidate
          onSubmit={handleSubmit}
          id="form-container"
          style={{ display: "flex", flexDirection: "column", gap: "2.5rem" }}
        >
          {/* ── Section 1 : Informations Personnelles ── */}
          <section
            style={{
              backgroundColor: "#f2f3fe",
              borderRadius: "0.75rem",
              padding: "2rem",
            }}
          >
            <div style={sectionHeaderStyle}>
              <span style={sectionBadgeStyle}>1</span>
              <h2 style={sectionTitleStyle}>Informations Personnelles</h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2" style={{ gap: "1.5rem" }}>
              {/* Prénom */}
              <div ref={firstNameRef}>
                <label htmlFor="firstName" style={labelStyle}>
                  Prénom
                </label>
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  value={form_Data.firstName}
                  onChange={handleChange}
                  required
                  placeholder="Entrez votre prénom"
                  style={inputStyle(
                    formErrors.firstName,
                    formValidated && !formErrors.firstName,
                  )}
                />
                {formErrors.firstName && (
                  <p style={errorStyle}>{formErrors.firstName}</p>
                )}
              </div>

              {/* Nom */}
              <div ref={lastNameRef}>
                <label htmlFor="lastName" style={labelStyle}>
                  Nom de famille
                </label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  value={form_Data.lastName}
                  onChange={handleChange}
                  required
                  placeholder="Entrez votre nom"
                  style={inputStyle(
                    formErrors.lastName,
                    formValidated && !formErrors.lastName,
                  )}
                />
                {formErrors.lastName && (
                  <p style={errorStyle}>{formErrors.lastName}</p>
                )}
              </div>

              {/* Établissement — full width */}
              <div className="md:col-span-2">
                <label htmlFor="establishment" style={labelStyle}>
                  Nom de l’école ou du centre
                </label>
                <Select
                  id="establishment"
                  name="establishment"
                  options={schools
                    .sort((a, b) => a.number - b.number)
                    .map((school) => ({
                      value: `${school.number} ${school.name}`,
                      label: `${school.number} ${school.name}`,
                    }))}
                  value={
                    form_Data.establishment
                      ? {
                          value: form_Data.establishment,
                          label: form_Data.establishment,
                        }
                      : null
                  }
                  onChange={(selectedOption) => {
                    const value = selectedOption ? selectedOption.value : "";
                    set_Form_Data((prevData) => {
                      const updatedData = { ...prevData, establishment: value };
                      if (firstFormValidation) {
                        setFormErrors(
                          validateFormData(
                            updatedData,
                            acknowledgeWarnings,
                            acknowledgeSignature,
                          ),
                        );
                      }
                      return updatedData;
                    });
                  }}
                  placeholder="Rechercher une école..."
                  classNamePrefix="react-select"
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      borderColor: formErrors.establishment
                        ? "#ba1a1a"
                        : formValidated && !formErrors.establishment
                          ? "#198754"
                          : "transparent",
                      backgroundColor: "#ffffff",
                      borderRadius: "0.5rem",
                      boxShadow: state.isFocused
                        ? "0 0 0 2px #00447f"
                        : "0 1px 3px rgba(0,0,0,0.08)",
                      minHeight: "48px",
                      "&:hover": { borderColor: "#00447f" },
                    }),
                    menu: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                  ref={establishmentRef}
                />
                {formErrors.establishment && (
                  <p style={errorStyle}>{formErrors.establishment}</p>
                )}
              </div>

              {/* Matricule */}
              <div ref={matriculeRef}>
                <label htmlFor="matricule" style={labelStyle}>
                  Numéro de matricule
                </label>
                <input
                  type="number"
                  id="matricule"
                  name="matricule"
                  value={form_Data.matricule}
                  onChange={handleChange}
                  onWheel={(e) => e.target.blur()}
                  required
                  placeholder="123456"
                  style={inputStyle(
                    formErrors.matricule,
                    formValidated && !formErrors.matricule,
                  )}
                />
                {formErrors.matricule && (
                  <p style={errorStyle}>{formErrors.matricule}</p>
                )}
              </div>

              {/* Téléphone */}
              <div ref={phoneRef}>
                <label
                  htmlFor="phone"
                  style={{
                    ...labelStyle,
                    color: formErrors.phoneNumber
                      ? "#ba1a1a"
                      : formValidated && !formErrors.phoneNumber
                        ? "#198754"
                        : "#414751",
                  }}
                >
                  Numéro de téléphone pour vous rejoindre
                </label>
                <div
                  style={{
                    backgroundColor: "#ffffff",
                    borderRadius: "0.5rem",
                    padding: "0.6rem 0.75rem",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                    border: formErrors.phoneNumber
                      ? "1.5px solid #ba1a1a"
                      : formValidated && !formErrors.phoneNumber
                        ? "1.5px solid #198754"
                        : "none",
                  }}
                >
                  <PhoneInput
                    defaultCountry="CA"
                    placeholder="XXX-XXX-XXXX"
                    value={form_Data.phoneNumber}
                    onChange={handlePhoneChange}
                    name="phoneNumber"
                    required
                  />
                </div>
                {formErrors.phoneNumber && (
                  <p style={errorStyle}>{formErrors.phoneNumber}</p>
                )}
              </div>
            </div>
          </section>

          {/* ── Section 2 : Type de demande ── */}
          <section
            ref={formTypeRef}
            style={{
              backgroundColor: "#f2f3fe",
              borderRadius: "0.75rem",
              padding: "2rem",
              border: formErrors.formType ? "1.5px solid #ba1a1a" : "none",
            }}
          >
            <div style={sectionHeaderStyle}>
              <span style={sectionBadgeStyle}>2</span>
              <h2 style={sectionTitleStyle}>Type de demande</h2>
            </div>
            <div className="form-grid-3" style={{ gap: "1rem" }}>
              {[
                {
                  id: "newLeaveRequest",
                  value: "newLeaveRequest",
                  icon: "add_circle",
                  label: "Nouvelle demande",
                  sublabel: "Soumettre une nouvelle demande",
                },
                {
                  id: "modifyLeaveRequest",
                  value: "modifyLeaveRequest",
                  icon: "edit",
                  label: "Modification",
                  sublabel: "Ajuster une demande existante",
                },
                {
                  id: "cancelLeaveRequest",
                  value: "cancelLeaveRequest",
                  icon: "cancel",
                  label: "Annulation",
                  sublabel: "Retirer une demande soumise",
                },
              ].map((opt) => {
                const isSelected = form_Data.formType === opt.value;
                return (
                  <label
                    key={opt.id}
                    htmlFor={opt.id}
                    style={{ cursor: "pointer" }}
                  >
                    <input
                      type="radio"
                      id={opt.id}
                      name="formType"
                      value={opt.value}
                      checked={isSelected}
                      onChange={handleFormTypeChange}
                      style={{ display: "none" }}
                    />
                    <div
                      style={{
                        padding: "1.5rem",
                        borderRadius: "0.75rem",
                        backgroundColor: isSelected
                          ? "rgba(0,68,127,0.08)"
                          : "#ecedf8",
                        border: isSelected
                          ? "2px solid #00447f"
                          : formErrors.formType
                            ? "2px solid #ba1a1a"
                            : "2px solid transparent",
                        transition: "all 0.15s ease",
                      }}
                    >
                      <span
                        className="material-symbols-outlined"
                        style={{
                          color: "#00447f",
                          fontSize: "1.75rem",
                          display: "block",
                          marginBottom: "0.5rem",
                        }}
                      >
                        {opt.icon}
                      </span>
                      <p
                        style={{
                          fontWeight: 700,
                          color: "#181c23",
                          marginBottom: "0.25rem",
                          fontSize: "0.95rem",
                        }}
                      >
                        {opt.label}
                      </p>
                      <p style={{ fontSize: "0.8rem", color: "#414751" }}>
                        {opt.sublabel}
                      </p>
                    </div>
                  </label>
                );
              })}
            </div>
            {formErrors.formType && (
              <p style={{ ...errorStyle, marginTop: "0.75rem" }}>
                {formErrors.formType}
              </p>
            )}
          </section>

          {form_Data.formType !== "cancelLeaveRequest" && (
            <>
              {/* ── Section 3 : Type de congé ── */}
              <section
                ref={leaveRequestTypeRef}
                style={{
                  backgroundColor: "#f2f3fe",
                  borderRadius: "0.75rem",
                  padding: "2rem",
                  border: formErrors.leaveRequestType
                    ? "1.5px solid #ba1a1a"
                    : "none",
                }}
              >
                <div style={sectionHeaderStyle}>
                  <span style={sectionBadgeStyle}>3</span>
                  <h2 style={sectionTitleStyle}>Type de congé</h2>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "0.75rem",
                  }}
                >
                  {[
                    {
                      id: "taskReduction",
                      value: "taskReduction",
                      label:
                        "Une réduction de tâche (congé partiel sans traitement)",
                    },
                    {
                      id: "noTreatment",
                      value: "noTreatment",
                      label:
                        "Un congé sans traitement à temps plein pour une période donnée.",
                    },
                  ].map((opt) => (
                    <label
                      key={opt.id}
                      htmlFor={opt.id}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.75rem",
                        backgroundColor:
                          form_Data.leaveRequestType === opt.value
                            ? "rgba(0,68,127,0.08)"
                            : "#ffffff",
                        border:
                          form_Data.leaveRequestType === opt.value
                            ? "1.5px solid #00447f"
                            : "1.5px solid #e2e4ea",
                        borderRadius: "0.5rem",
                        padding: "1rem 1.25rem",
                        cursor: "pointer",
                      }}
                    >
                      <input
                        type="radio"
                        id={opt.id}
                        name="leaveRequestType"
                        value={opt.value}
                        checked={form_Data.leaveRequestType === opt.value}
                        onChange={handleLeaveRequestTypeChange}
                        style={{
                          accentColor: "#00447f",
                          width: 18,
                          height: 18,
                          flexShrink: 0,
                          cursor: "pointer",
                        }}
                      />
                      <span style={{ fontSize: "0.95rem", color: "#181c23" }}>
                        {opt.label}
                      </span>
                    </label>
                  ))}
                </div>
                {formErrors.leaveRequestType && (
                  <p style={{ ...errorStyle, marginTop: "0.75rem" }}>
                    {formErrors.leaveRequestType}
                  </p>
                )}
              </section>
              <AnimatePresence>
                {form_Data.leaveRequestType !== "" && (
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    ref={dateTypeRef}
                  >
                    {/* ── Section 4 : Durée souhaitée ── */}
                    <section
                      style={{
                        backgroundColor: "#f2f3fe",
                        borderRadius: "0.75rem",
                        padding: "2rem",
                        border:
                          formErrors.dateType && !formErrors.dateRange
                            ? "1.5px solid #ba1a1a"
                            : "none",
                      }}
                    >
                      <div style={sectionHeaderStyle}>
                        <span style={sectionBadgeStyle}>4</span>
                        <h2 style={sectionTitleStyle}>Durée souhaitée</h2>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "0.75rem",
                        }}
                      >
                        {[
                          {
                            id: "anneeScolaire",
                            value: "anneeScolaire",
                            label: "Pour toute la prochaine année scolaire",
                          },
                          {
                            id: "choixDeDate",
                            value: "choixDeDate",
                            label: "Choisir les dates précises du congé",
                          },
                        ].map((opt) => (
                          <label
                            key={opt.id}
                            htmlFor={opt.id}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "0.75rem",
                              backgroundColor:
                                form_Data.dateType === opt.value
                                  ? "rgba(0,68,127,0.08)"
                                  : "#ffffff",
                              border:
                                form_Data.dateType === opt.value
                                  ? "1.5px solid #00447f"
                                  : "1.5px solid #e2e4ea",
                              borderRadius: "0.5rem",
                              padding: "1rem 1.25rem",
                              cursor: "pointer",
                            }}
                          >
                            <input
                              type="radio"
                              id={opt.id}
                              name="dateType"
                              value={opt.value}
                              checked={form_Data.dateType === opt.value}
                              onChange={handleDateTypeChange}
                              style={{
                                accentColor: "#00447f",
                                width: 18,
                                height: 18,
                                flexShrink: 0,
                                cursor: "pointer",
                              }}
                            />
                            <span
                              style={{ fontSize: "0.95rem", color: "#181c23" }}
                            >
                              {opt.label}
                            </span>
                          </label>
                        ))}
                      </div>
                      {formErrors.dateType && (
                        <p style={{ ...errorStyle, marginTop: "0.75rem" }}>
                          {formErrors.dateType}
                        </p>
                      )}
                      <AnimatePresence>
                        {form_Data.dateType === "choixDeDate" && (
                          <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            transition={{ duration: 0.3 }}
                            style={{ marginTop: "1.5rem" }}
                          >
                            <p
                              style={{ ...labelStyle, marginBottom: "0.5rem" }}
                            >
                              Début du congé
                            </p>
                            <SundayCalendarComp
                              onChange={(date) =>
                                set_Form_Data((prevData) => ({
                                  ...prevData,
                                  startDate: date,
                                }))
                              }
                            />
                            <p
                              style={{
                                ...labelStyle,
                                marginTop: "1.25rem",
                                marginBottom: "0.5rem",
                              }}
                            >
                              Fin du congé
                            </p>
                            <SundayCalendarComp
                              onChange={(date) =>
                                set_Form_Data((prevData) => ({
                                  ...prevData,
                                  endDate: date,
                                }))
                              }
                            />
                            {formErrors.dateRange && (
                              <p style={{ ...errorStyle, marginTop: "0.5rem" }}>
                                {formErrors.dateRange}
                              </p>
                            )}
                          </motion.div>
                        )}
                      </AnimatePresence>
                    </section>
                  </motion.div>
                )}
              </AnimatePresence>

              <AnimatePresence>
                {form_Data.leaveRequestType === "taskReduction" &&
                  form_Data.dateType && (
                    <motion.div
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      exit={{ opacity: 0 }}
                      transition={{ duration: 0.5 }}
                      ref={disciplineTaskReductionRef}
                    >
                      {/* ── Section 5 : Discipline ── */}
                      <section
                        style={{
                          backgroundColor: "#f2f3fe",
                          borderRadius: "0.75rem",
                          padding: "2rem",
                          border: formErrors.discipline
                            ? "1.5px solid #ba1a1a"
                            : "none",
                        }}
                      >
                        <div style={sectionHeaderStyle}>
                          <span style={sectionBadgeStyle}>5</span>
                          <h2 style={sectionTitleStyle}>
                            Discipline d’enseignement
                          </h2>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "0.5rem",
                          }}
                        >
                          {[
                            { id: "Prescolaire", label: "Préscolaire" },
                            {
                              id: "TitulairePrimaire",
                              label:
                                "Titulaire primaire OU francisation primaire OU annexe 49",
                            },
                            {
                              id: "AdaptionScholaire",
                              label: "Adaptation scolaire (primaire)",
                            },
                            {
                              id: "AnglaisPrimaire",
                              label: "Anglais - spécialiste primaire",
                            },
                            {
                              id: "MusiquePrimaire",
                              label: "Musique - spécialiste primaire",
                            },
                            {
                              id: "ArtsPrimaire",
                              label: "Arts - spécialiste primaire",
                            },
                            {
                              id: "EducationPhysiquePrimaire",
                              label:
                                "Éducation physique - spécialiste primaire",
                            },
                            {
                              id: "EnseignantSecondaire5Jours",
                              label:
                                "Enseignant(e) au secondaire avec un horaire sur 5 jours",
                            },
                            {
                              id: "EnseignantSecondaire9Jours",
                              label:
                                "Enseignant(e) au secondaire avec un horaire sur 9 jours",
                            },
                            {
                              id: "EnseignantAdultes",
                              label: "Enseignant(e) à l’éducation des adultes",
                            },
                            {
                              id: "FormationProfessionelle",
                              label:
                                "Enseignant(e) en formation professionnelle",
                            },
                            {
                              id: "EnseignantMarieLeneuf",
                              label: "Enseignant(e) de l’école Marie-Leneuf",
                            },
                          ].map((option) => (
                            <label
                              key={option.id}
                              htmlFor={option.id}
                              style={{
                                display: "flex",
                                alignItems: "flex-start",
                                gap: "0.75rem",
                                backgroundColor:
                                  form_Data.discipline === option.id
                                    ? "rgba(0,68,127,0.08)"
                                    : "#ffffff",
                                border:
                                  form_Data.discipline === option.id
                                    ? "1.5px solid #00447f"
                                    : "1.5px solid #e2e4ea",
                                borderRadius: "0.5rem",
                                padding: "0.875rem 1.25rem",
                                cursor: "pointer",
                              }}
                            >
                              <input
                                type="radio"
                                id={option.id}
                                name="discipline"
                                value={option.id}
                                checked={form_Data.discipline === option.id}
                                onChange={handleDisciplineChange}
                                style={{
                                  accentColor: "#00447f",
                                  width: 18,
                                  height: 18,
                                  flexShrink: 0,
                                  marginTop: 2,
                                  cursor: "pointer",
                                }}
                              />
                              <span
                                style={{
                                  fontSize: "0.9rem",
                                  color: "#181c23",
                                  lineHeight: 1.5,
                                }}
                              >
                                {option.label}
                              </span>
                            </label>
                          ))}
                        </div>
                        {formErrors.discipline && (
                          <p style={{ ...errorStyle, marginTop: "0.75rem" }}>
                            {formErrors.discipline}
                          </p>
                        )}
                      </section>
                    </motion.div>
                  )}
              </AnimatePresence>

              {primaireOptions.some(
                (option) => option.id === form_Data.discipline,
              ) && (
                <div
                  style={{
                    backgroundColor: "#f2f3fe",
                    borderRadius: "0.75rem",
                    padding: "2rem",
                  }}
                  id="primaireInputField"
                >
                  <p
                    style={{
                      ...labelStyle,
                      fontSize: "0.95rem",
                      marginBottom: "1rem",
                    }}
                  >
                    Pourcentage du congé ne nécessitant pas un rachat au fonds
                    de pension. Veuillez indiquer l'information demandée.
                    Veuillez cocher le congé que vous prendrez :
                  </p>
                  <Primaire
                    handlePrimaireChange={handlePrimaireChange}
                    otherPercent={form_Data.otherPercent}
                    percentChoice={form_Data.percentChoice}
                    setPercentChoice={(choice) =>
                      set_Form_Data((prevData) => ({
                        ...prevData,
                        percentChoice: choice,
                        otherPercent: choice === "other",
                        percent: choice === "predefined" ? "19.51" : "",
                        leaveDetail:
                          choice === "predefined"
                            ? "Primaire, par 10 jours (Congé de 19,51%): 2 journées de congé de 4 périodes"
                            : "",
                      }))
                    }
                    onPercentChange={handleChange}
                    handleOtherPercentChange={handleOtherPercentChange}
                    percent={form_Data.percent}
                    formErrors={formErrors}
                    validated={formValidated && !formErrors.percent}
                  />
                </div>
              )}

              {form_Data.discipline === "Prescolaire" && (
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.3 }}
                  ref={preschoaireRef}
                >
                  <div
                    style={{
                      backgroundColor: "#f2f3fe",
                      borderRadius: "0.75rem",
                      padding: "2rem",
                      border: formErrors.percent
                        ? "1.5px solid #ba1a1a"
                        : "none",
                    }}
                    id="primaireInputField"
                  >
                    <p
                      style={{
                        ...labelStyle,
                        fontSize: "0.95rem",
                        marginBottom: "1rem",
                      }}
                    >
                      Veuillez indiquer l'information demandée. Veuillez cocher
                      le congé que vous prendrez :
                    </p>
                    <div
                      id="prescolaireRadioField"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "0.5rem",
                      }}
                    >
                      {[
                        {
                          id: "PrescolaireConge1644",
                          value: "16.44",
                          label:
                            "Préscolaire, par 10 jours (Congé de 16,44%): 2 journées de congé avec un spécialiste de 60 minutes à chacune de ces journées",
                        },
                        {
                          id: "Prescolaire1Conge1867",
                          value: "18.67",
                          label:
                            "Préscolaire, par 10 jours (congé de 18,67%): 1 journée complète de congé et 1 journée avec un spécialiste de 60 minutes",
                        },
                        {
                          id: "Prescolaire2Conge1867",
                          value: "18.67",
                          label:
                            "Préscolaire, par 10 jours (Congé de 18,67%): 2 journées de congé avec un spécialiste de 30 minutes lors de ces journées",
                        },
                        {
                          id: "PrescolaireConge1978",
                          value: "19.78",
                          label:
                            "Préscolaire, par 10 jours (Congé de 19,78%): 1 journée complète de congé et 1 journée de congé avec un spécialiste de 30 minutes",
                        },
                        {
                          id: "PrescolaireConge2089",
                          value: "20.89",
                          label:
                            "Préscolaire, par 10 jours (congé de 20,89%) : 2 journées complètes de congé sans spécialiste",
                        },
                        {
                          id: "PrescolaireConge2689",
                          value: "26.89",
                          label:
                            "Préscolaire, par 10 jours (congé de 26,89%) : 1 journée complète de congé et 2 journées de congé avec un spécialiste de 60 minutes",
                        },
                        {
                          id: "PrescolaireConge3133",
                          value: "31.33",
                          label:
                            "Préscolaire, par 10 jours (congé de 31,33%) : 3 journées complètes de congé sans spécialiste",
                        },
                      ].map((opt) => (
                        <label
                          key={opt.id}
                          htmlFor={opt.id}
                          style={{
                            display: "flex",
                            alignItems: "flex-start",
                            gap: "0.75rem",
                            backgroundColor: "#ffffff",
                            border: "1.5px solid #e2e4ea",
                            borderRadius: "0.5rem",
                            padding: "0.875rem 1.25rem",
                            cursor: "pointer",
                          }}
                        >
                          <input
                            type="radio"
                            id={opt.id}
                            name="congeOption"
                            value={opt.value}
                            onChange={handleMarieChange}
                            style={{
                              accentColor: "#00447f",
                              width: 18,
                              height: 18,
                              flexShrink: 0,
                              marginTop: 2,
                              cursor: "pointer",
                            }}
                          />
                          <span
                            style={{
                              fontSize: "0.875rem",
                              color: "#181c23",
                              lineHeight: 1.5,
                            }}
                          >
                            {opt.label}
                          </span>
                        </label>
                      ))}
                      <label
                        htmlFor="PrescolaireCongeAutre"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "0.75rem",
                          backgroundColor: form_Data.otherPercent
                            ? "rgba(0,68,127,0.08)"
                            : "#ffffff",
                          border: form_Data.otherPercent
                            ? "1.5px solid #00447f"
                            : "1.5px solid #e2e4ea",
                          borderRadius: "0.5rem",
                          padding: "0.875rem 1.25rem",
                          cursor: "pointer",
                        }}
                      >
                        <input
                          type="radio"
                          id="PrescolaireCongeAutre"
                          name="congeOption"
                          onChange={handleOtherPercentChange}
                          style={{
                            accentColor: "#00447f",
                            width: 18,
                            height: 18,
                            flexShrink: 0,
                            cursor: "pointer",
                          }}
                        />
                        <span
                          style={{ fontSize: "0.875rem", color: "#181c23" }}
                        >
                          Autre (veuillez indiquer le pourcentage de votre congé
                          ci-dessous)
                        </span>
                      </label>
                      {form_Data.otherPercent && (
                        <div style={{ marginTop: "0.5rem" }}>
                          <PercentInput
                            value={form_Data.percent}
                            onChange={handleChange}
                            error={formErrors.percent}
                            validated={formValidated && !formErrors.percent}
                          />
                        </div>
                      )}
                      {formErrors.percent && (
                        <p style={errorStyle}>{formErrors.percent}</p>
                      )}
                    </div>
                  </div>
                </motion.div>
              )}

              <AnimatePresence>
                {form_Data.discipline === "EnseignantMarieLeneuf" && (
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <MariePercent
                      handleMarieChange={handleMarieChange}
                      formErrors={formErrors}
                      otherPercent={form_Data.otherPercent}
                      handleOtherPercentChange={handleOtherPercentChange}
                      validated={formValidated && !formErrors.percent}
                      onPercentChange={handleChange}
                      percent={form_Data.percent}
                    />
                  </motion.div>
                )}
              </AnimatePresence>

              <AnimatePresence>
                {form_Data.discipline === "EnseignantSecondaire9Jours" && (
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <NineDays
                      onFiveDaysChange={handlePercentChangeFor5And9Days}
                      formErrors={formErrors}
                      formValidated={formValidated}
                      percentChoice={form_Data.percentChoice}
                      setPercentChoice={(choice) =>
                        set_Form_Data((prev) => ({
                          ...prev,
                          percentChoice: choice,
                          percent: "",
                        }))
                      }
                      onPercentChange={handleChange}
                      percent={form_Data.percent}
                      validated={formValidated && !formErrors.percent}
                    />
                  </motion.div>
                )}
              </AnimatePresence>

              <AnimatePresence>
                {form_Data.discipline === "EnseignantSecondaire5Jours" && (
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <FiveDays
                      onFiveDaysChange={handlePercentChangeFor5And9Days}
                      formErrors={formErrors}
                      formValidated={formValidated}
                      percentChoice={form_Data.percentChoice}
                      setPercentChoice={(choice) =>
                        set_Form_Data((prev) => ({
                          ...prev,
                          percentChoice: choice,
                          percent: "",
                        }))
                      }
                      onPercentChange={handleChange}
                      percent={form_Data.percent}
                      validated={formValidated && !formErrors.percent}
                    />
                  </motion.div>
                )}
              </AnimatePresence>

              <AnimatePresence>
                {(form_Data.discipline === "EnseignantAdultes" ||
                  form_Data.discipline === "FormationProfessionelle") && (
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    id="percent"
                  >
                    <div style={{ maxWidth: "20rem" }}>
                      <PercentInput
                        value={form_Data.percent}
                        onChange={handleChange}
                        error={formErrors.percent}
                        validated={formValidated && !formErrors.percent}
                      />
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>

              <AnimatePresence>
                {form_Data.leaveRequestType === "taskReduction" &&
                  !!form_Data.percent && (
                    <motion.div
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      exit={{ opacity: 0 }}
                      transition={{ duration: 0.5 }}
                    >
                      {/* ── Section 6 : Nature du congé ── */}
                      <section
                        style={{
                          backgroundColor: "#f2f3fe",
                          borderRadius: "0.75rem",
                          padding: "2rem",
                          border: formErrors.reason
                            ? "1.5px solid #ba1a1a"
                            : "none",
                        }}
                      >
                        <div style={sectionHeaderStyle}>
                          <span style={sectionBadgeStyle}>6</span>
                          <h2 style={sectionTitleStyle}>Nature du congé</h2>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "0.5rem",
                          }}
                        >
                          {[
                            {
                              id: "enfantMoinsCinq",
                              value: "enfant",
                              label: (
                                <>
                                  Pour prendre soin de son enfant de moins de 5
                                  ans. Voir les{" "}
                                  <a
                                    href="/R%C3%A9duction%20de%20t%C3%A2che%20-%20Balises%20CSS-%202026-2027.pdf"
                                    target="_blank"
                                    rel="noreferrer"
                                    style={{ color: "#00447f" }}
                                  >
                                    balises du CSS
                                  </a>{" "}
                                  concernant les modalités pouvant amener la fin
                                  de votre congé.
                                </>
                              ),
                            },
                            {
                              id: "causeHumanitaire",
                              value: "humanitaire",
                              label:
                                "Pour cause humanitaire (ex.: décès d'un conjoint, prendre soin d'un parent à charge, maladie grave d'un conjoint ou d'un enfant, à charge...) — Veuillez indiquer le motif ci-dessous",
                            },
                            {
                              id: "causeSante",
                              value: "sante",
                              label:
                                "Votre état de santé ne vous permet pas d'effectuer votre prestation complète de travail",
                            },
                            {
                              id: "pourEtudes",
                              value: "etudes",
                              label:
                                "Pour études (DOCUMENT D'INSCRIPTION À FOURNIR)",
                            },
                            {
                              id: "priseRetraite",
                              value: "retraite",
                              label: "Prise de retraite dans 5 ans ou moins",
                            },
                            {
                              id: "raisonPersonelle",
                              value: "perso",
                              label: (
                                <>
                                  Raison personnelle (aucun des derniers motifs
                                  énumérés plus haut). Voir les{" "}
                                  <a
                                    href="/R%C3%A9duction%20de%20t%C3%A2che%20-%20Balises%20CSS-%202026-2027.pdf"
                                    target="_blank"
                                    rel="noreferrer"
                                    style={{ color: "#00447f" }}
                                  >
                                    balises du CSS
                                  </a>{" "}
                                  concernant les modalités pouvant amener la fin
                                  de votre congé.
                                </>
                              ),
                            },
                          ].map((opt) => (
                            <label
                              key={opt.id}
                              htmlFor={opt.id}
                              style={{
                                display: "flex",
                                alignItems: "flex-start",
                                gap: "0.75rem",
                                backgroundColor:
                                  form_Data.reason === opt.value
                                    ? "rgba(0,68,127,0.08)"
                                    : "#ffffff",
                                border:
                                  form_Data.reason === opt.value
                                    ? "1.5px solid #00447f"
                                    : "1.5px solid #e2e4ea",
                                borderRadius: "0.5rem",
                                padding: "0.875rem 1.25rem",
                                cursor: "pointer",
                              }}
                            >
                              <input
                                type="radio"
                                id={opt.id}
                                name="nature_conge"
                                value={opt.value}
                                checked={form_Data.reason === opt.value}
                                onChange={handleReasonChange}
                                style={{
                                  accentColor: "#00447f",
                                  width: 18,
                                  height: 18,
                                  flexShrink: 0,
                                  marginTop: 2,
                                  cursor: "pointer",
                                }}
                              />
                              <span
                                style={{
                                  fontSize: "0.9rem",
                                  color: "#181c23",
                                  lineHeight: 1.5,
                                }}
                              >
                                {opt.label}
                              </span>
                            </label>
                          ))}
                        </div>

                        {form_Data.reason === "humanitaire" && (
                          <div style={{ marginTop: "1.25rem" }}>
                            <label
                              htmlFor="humanitaireDetails"
                              style={labelStyle}
                            >
                              Veuillez inscrire le motif de la cause humanitaire
                              :
                            </label>
                            <textarea
                              id="humanitaireDetails"
                              rows="3"
                              value={form_Data.humanitaireDetails}
                              onChange={handleHumanitaireDetailsChange}
                              style={{
                                ...inputStyle(
                                  formErrors.humanitaireDetails,
                                  formValidated &&
                                    !formErrors.humanitaireDetails,
                                ),
                                resize: "vertical",
                              }}
                            />
                            {formErrors.humanitaireDetails && (
                              <p style={errorStyle}>
                                {formErrors.humanitaireDetails}
                              </p>
                            )}
                          </div>
                        )}

                        {formErrors.reason && (
                          <p style={{ ...errorStyle, marginTop: "0.75rem" }}>
                            {formErrors.reason}
                          </p>
                        )}

                        {(form_Data.reason === "etudes" ||
                          form_Data.reason === "sante") && (
                          <div style={{ marginTop: "1.25rem" }}>
                            <FileInput />
                          </div>
                        )}
                      </section>
                    </motion.div>
                  )}
              </AnimatePresence>

              {form_Data.leaveRequestType === "noTreatment" &&
                form_Data.dateType && (
                  <AnimatePresence>
                    <NatureCongeSansTraitement />
                  </AnimatePresence>
                )}

              {/* Warning: percent > 20 */}
              <AnimatePresence>
                {form_Data.percent > 20 && (
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    ref={acknowledgeWarningsRef}
                  >
                    <div
                      style={{
                        backgroundColor: "#fff8e6",
                        border: `1.5px solid ${formErrors.acknowledgeWarnings ? "#ba1a1a" : "#f59e0b"}`,
                        borderRadius: "0.75rem",
                        padding: "1.5rem",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "flex-start",
                          gap: "0.75rem",
                        }}
                      >
                        <input
                          type="checkbox"
                          id="acknowledgeWarnings"
                          checked={acknowledgeWarnings}
                          onChange={handleAcknowledgeChange}
                          style={{
                            accentColor: "#00447f",
                            width: 18,
                            height: 18,
                            flexShrink: 0,
                            marginTop: 3,
                            cursor: "pointer",
                          }}
                        />
                        <label
                          htmlFor="acknowledgeWarnings"
                          style={{
                            fontSize: "0.875rem",
                            color: "#7c3800",
                            lineHeight: 1.6,
                            cursor: "pointer",
                          }}
                        >
                          <strong>IMPORTANT</strong> : JE COMPRENDS QUE SI LE
                          POURCENTAGE DE MON <strong>CONGÉ</strong> EST{" "}
                          <strong>SUPÉRIEUR À 20%</strong>, JE DEVRAI PROCÉDER À
                          UN <strong>RACHAT DE MON FONDS DE PENSION</strong>{" "}
                          POUR FAIRE RECONNAÎTRE PLEINEMENT MON ANNÉE DE TRAVAIL
                          ET <strong>NE PAS ÊTRE "PÉNALISÉ"</strong> POUR MA
                          RETRAITE. SI JE SOUHAITE PROCÉDER À CE RACHAT, JE
                          POURRAI FAIRE UNE DÉMARCHE AVEC LE SEVF LORS DE MON
                          RETOUR AU TRAVAIL{" "}
                          <strong>(APRÈS LA FIN DE MON CONGÉ).</strong>
                        </label>
                      </div>
                      {formErrors.acknowledgeWarnings && (
                        <p style={{ ...errorStyle, marginTop: "0.5rem" }}>
                          {formErrors.acknowledgeWarnings}
                        </p>
                      )}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>

              {/* Confirmation / Signature */}
              <AnimatePresence>
                {form_Data.reason && (
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    ref={acknowledgeSignatureRef}
                  >
                    <div
                      style={{
                        backgroundColor: "#f2f3fe",
                        borderRadius: "0.75rem",
                        padding: "1.5rem",
                        border: formErrors.acknowledgeSignature
                          ? "1.5px solid #ba1a1a"
                          : "none",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "flex-start",
                          gap: "0.75rem",
                        }}
                      >
                        <input
                          type="checkbox"
                          id="acknowledgeSignature"
                          checked={acknowledgeSignature}
                          onChange={handleAcknowledgeSignatureChange}
                          style={{
                            accentColor: "#00447f",
                            width: 18,
                            height: 18,
                            flexShrink: 0,
                            marginTop: 3,
                            cursor: "pointer",
                          }}
                        />
                        <label
                          htmlFor="acknowledgeSignature"
                          style={{
                            fontSize: "0.875rem",
                            color: "#414751",
                            lineHeight: 1.6,
                            cursor: "pointer",
                          }}
                        >
                          En cochant cette case, je confirme que les
                          informations fournies dans ce formulaire sont exactes
                          et conformes à ma situation. Je fais une demande
                          officielle, laquelle sera transmise aux services des
                          ressources humaines du Centre de services scolaire du
                          Chemin-du-Roy pour traitement, et une copie sera
                          acheminée au Syndicat de l'enseignement des
                          Vieilles-Forges.{" "}
                          <strong>
                            Je comprends que le fait de cocher cette case fait
                            office de signature officielle.
                          </strong>
                        </label>
                      </div>
                      {formErrors.acknowledgeSignature && (
                        <p style={{ ...errorStyle, marginTop: "0.5rem" }}>
                          {formErrors.acknowledgeSignature}
                        </p>
                      )}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>

              {/* Email verification */}
              {acknowledgeSignature && (
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.3 }}
                >
                  <EmailVerification
                    apiUrl={apiUrl}
                    domain={
                      apiUrl?.includes("ngrok")
                        ? ""
                        : apiUrl?.includes("localhost")
                          ? "@gmail.com"
                          : "@csscdr.gouv.qc.ca"
                    }
                    error={formErrors.emailVerification}
                    onVerified={(email) => {
                      if (!form_Data.emailVerified) {
                        set_Form_Data((prev) => ({
                          ...prev,
                          emailVerified: true,
                          emailToVerify: email,
                        }));
                        setFormErrors((prev) => ({
                          ...prev,
                          emailVerification: undefined,
                        }));
                      }
                    }}
                  />
                </motion.div>
              )}
            </>
          )}

          {form_Data.formType === "cancelLeaveRequest" && (
            <>
              <AnimatePresence>
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.3 }}
                  ref={acknowledgeSignatureRef}
                >
                  <div
                    style={{
                      backgroundColor: "#f2f3fe",
                      borderRadius: "0.75rem",
                      padding: "1.5rem",
                      border: formErrors.acknowledgeSignature
                        ? "1.5px solid #ba1a1a"
                        : "none",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "0.75rem",
                      }}
                    >
                      <input
                        type="checkbox"
                        id="acknowledgeSignature"
                        checked={acknowledgeSignature}
                        onChange={handleAcknowledgeSignatureChange}
                        style={{
                          accentColor: "#00447f",
                          width: 18,
                          height: 18,
                          flexShrink: 0,
                          marginTop: 3,
                          cursor: "pointer",
                        }}
                      />
                      <label
                        htmlFor="acknowledgeSignature"
                        style={{
                          fontSize: "0.875rem",
                          color: "#414751",
                          lineHeight: 1.6,
                          cursor: "pointer",
                        }}
                      >
                        Je souhaite officiellement annuler ma dernière demande
                        de congé sans traitement que j’avais produite. Le Centre
                        de services procédera à l’analyse et vous confirmera si
                        cette demande est acceptée.
                      </label>
                    </div>
                    {formErrors.acknowledgeSignature && (
                      <p style={{ ...errorStyle, marginTop: "0.5rem" }}>
                        {formErrors.acknowledgeSignature}
                      </p>
                    )}
                  </div>
                </motion.div>
              </AnimatePresence>
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.3 }}
              >
                <EmailVerification
                  apiUrl={apiUrl}
                  domain={
                    apiUrl?.includes("ngrok")
                      ? ""
                      : apiUrl?.includes("localhost")
                        ? "@gmail.com"
                        : "@csscdr.gouv.qc.ca"
                  }
                  error={formErrors.emailVerification}
                  onVerified={(email) => {
                    if (!form_Data.emailVerified) {
                      set_Form_Data((prev) => ({
                        ...prev,
                        emailVerified: true,
                        emailToVerify: email,
                      }));
                      setFormErrors((prev) => ({
                        ...prev,
                        emailVerification: undefined,
                      }));
                    }
                  }}
                />
              </motion.div>
            </>
          )}

          <button
            type="submit"
            style={{
              backgroundColor: "#00447f",
              color: "#ffffff",
              border: "none",
              borderRadius: "0.5rem",
              padding: "0.875rem 2.5rem",
              fontSize: "1rem",
              fontWeight: 600,
              cursor: "pointer",
              fontFamily: "Public Sans, sans-serif",
              alignSelf: "flex-start",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.backgroundColor = "#005ca8")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.backgroundColor = "#00447f")
            }
          >
            Envoyer
          </button>
          {submitError && (
            <div
              style={{
                marginTop: "1rem",
                padding: "1rem 1.25rem",
                backgroundColor: "#fff0f0",
                border: "1.5px solid #ba1a1a",
                borderRadius: "0.625rem",
                color: "#ba1a1a",
                fontSize: "0.9rem",
                lineHeight: 1.5,
              }}
            >
              {submitError}
            </div>
          )}
          {/* Loading indicator */}
          {loading && (
            <div className="loading-overlay">
              <img src="/loading-logo.gif" alt="Loading..." />
            </div>
          )}
        </form>
      </div>
    </div>
  );
}

export default FormulaireAbsence;
